import {
    TextHelper,
    SmallTextHelper,
    UrlHelper,
    ArrayHelper,
    NumberHelper
} from '../../PrismicHelpers';

export const sliceTrustedByBarSlice = (data) => {
    const dataType = data.slice_type;
    let dataToSend = {
        type: dataType
    };
    return dataToSend;
}

export const trustedByBarHelper = (response) => {
    const trustedByBarData = response.results[0].data;

    let trustedByBarObject = {
        bg_color: SmallTextHelper(trustedByBarData.bg_color),
        text_color: SmallTextHelper(trustedByBarData.text_color),
        title: TextHelper(trustedByBarData.title),
        companies: trustedByBarData.companies && trustedByBarData.companies.length > 0 ? trustedByBarData.companies.map(company => {
            return {
                order: NumberHelper(company.order),
                logo: UrlHelper(company.logo),
                alternative_text_photo: TextHelper(company.alternative_text_photo),
            }
        }) : null
    }

    trustedByBarObject.companies = trustedByBarObject.companies.sort(
        function (a, b) {
            return a.order - b.order;
        }
    );

    return { trustedByBar: trustedByBarObject };
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/sliceTrustedByBarSlice.js